import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  private path = '/reports';

  constructor(private backendService:BackendService) { }


  getReport (data:any){
    return this.backendService.post (this.path, data);
  }


  getExamStatus (data:any){
    return this.backendService.post (this.path  +"/exam_status", data);
  }

  getVerificationStatus(testcenter: any, batchid: any, verification_status: string = 'all') {
    let p = `${this.path}/verification_status/${testcenter}/${batchid}/${verification_status}`;
    
    return this.backendService.get(p);
  }

  getExamProgress(testcenter: any, batchid: any, type: string) {
    let p = `${this.path}/exam_progress/${testcenter}/${batchid}/${type}`;
    return this.backendService.get(p);
  }

  getScoreReport (criteria:any, filter, size, page){

    var data = {
      pagination: {
        page: page,
        size: size
      },
      filter: filter
    };
    data = Object.assign (data, criteria || {});

    return this.backendService.post (this.path  +"/score", data);
  }

  getCandidateReport (data:any){

    ///candidate/:center/:batch/:candidateid
    var p = this.path + "/candidate/" + data.center + "/" + data.batch + "/" + data.candidate;
    return this.backendService.get (p);
  }

  getCandidateLogs (criteria:any, filter, size, page){

    var data = {
      pagination: {
        page: page,
        size: size
      },
      filter: filter
    };
    data = Object.assign (data, criteria || {});
    var p = this.path + "/candidate/" + criteria.center + "/" + criteria.batch + "/" + criteria.candidate + "/logs"
    return this.backendService.post (p, data);
  }

  getCandidateQuestions (criteria:any){

   
     
    var p = this.path + "/candidate/" + criteria.center + "/" + criteria.batch + "/" + criteria.candidate + "/questions"
    return this.backendService.get (p);
  }


 
   getCandidateSeats (criteria:any){

   
   
    var p = this.path + "/candidate/" + criteria.center + "/" + criteria.batch + "/" + criteria.candidate + "/seats"
    return this.backendService.get (p);
  }

  clearDashboard() {
    return this.backendService.post(this.path + "/clear_dashboard", {});
  }

}
